import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  MenuItem,
  Switch,
  Button,
  Grid,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ChevronRight } from "@material-ui/icons";


const DocumentAccessDialog = ({ open, handleClose, classes }) => {
  const [viewDocument, setViewDocument] = useState("When document is uploaded");
  const [commentOption, setCommentOption] = useState("");
  const [initialComments, setInitialComments] = useState(true);

  const handleSaveChanges = () => {
    //console.log("Saved Changes");
    // Implement your save logic here
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      {/* Dialog Title */}
      <DialogTitle disableTypography>
              <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item xs={10}>
              <Typography style={{fontWeight:500, fontSize:'1.5rem'}} className={classes.flexGrow}>
              Document access settings for external stakeholders
                      </Typography>
                  </Grid>
                  <Grid item xs={2}>
                  <div
                      className={classes.closeText}
              onClick={handleClose}
              >
          <Typography
            variant="body2"
            style={{ fontWeight:500,cursor: "pointer" }}
            
          >
            Cancel 
              </Typography>
                <CloseIcon style={{color:'#FF0000'}} />
                      </div>
                      </Grid>
        </Grid>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent>
        {/* View the document */}
        <Typography variant="subtitle1" gutterBottom>
          View the document <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          select
          value={viewDocument}
          onChange={(e) => setViewDocument(e.target.value)}
          variant="outlined"
          fullWidth
          size="small"
          margin="dense"
        >
          <MenuItem value="">
            <em>Select an option</em>
          </MenuItem>
          <MenuItem value="When document is uploaded">
            When document is uploaded
          </MenuItem>
          <MenuItem value="When initial internal approvals are complete (if any)">
            When initial internal approvals are complete (if any)
          </MenuItem>
        </TextField>

        {/* View and add comments */}
        <Typography variant="subtitle1" gutterBottom style={{ marginTop: "16px" }}>
          View and add comments in the comments section{" "}
          <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          select
          value={commentOption}
          onChange={(e) => setCommentOption(e.target.value)}
          variant="outlined"
          fullWidth
          size="small"
          margin="dense"
        >
          <MenuItem value="">
            <em>Select an option</em>
          </MenuItem>
          <MenuItem value="When document is uploaded">
            When document is uploaded
          </MenuItem>
          <MenuItem value="When initial internal approvals are complete (if any)">
            When initial internal approvals are complete (if any)
          </MenuItem>
        </TextField>

        {/* Toggle initial comments */}
              <Grid container alignItems="center" style={{ marginTop: "16px" }}>
                  <Grid item xs={10}>
          <Typography variant="subtitle1">
            View initial comments (before document is assigned for external
            approvals) of the internal stakeholders in the comments section.
                      </Typography>
                  </Grid>
                  <Grid item xs={2}>
          <Switch
            checked={initialComments}
            onChange={() => setInitialComments(!initialComments)}
            color="primary"
                      />
                      </Grid>
        </Grid>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions style={{justifyContent:'center'}}>
              <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "2rem",
          paddingTop: "1rem",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          endIcon={<ChevronRight />}
          style={{ borderRadius: "20px", textTransform: "none" }}
          onClick={handleSaveChanges}
        >
          Save changes
        </Button>
      </div>
      </DialogActions>
    </Dialog>
  );
};


export default DocumentAccessDialog;
